module.exports = __webpack_public_path__ + "img/google.e66ba2f8.svg";